<template>
  <div class="main">
    <p>222</p>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
export default {
  name: 'ImportantKnowledge',
  components: {

  },
  created () {

  },
  data () {
    return {

    }
  },
  watch: {
    mlVisible () {

    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

</style>
